// @flow
import React from 'react';
import styled from 'styled-components';
import AddonsTabContainer from './addons-tab/AddonsTabContainer';
import LedgerAccountsHeader from './LedgerAccountsHeader';
import LedgerAccountsTabContainer from './ledger-accounts-tab/LedgerAccountsTabContainer';
import ledgerAccountsTabs from './ledgerAccountsTabs';
import type { LedgerAccountsTabs } from './types';
import BKToolsErrorBoundary from '../BKToolsErrorBoundary';
import { useClient } from '../ClientContext';

const LEDGER_ACCOUNTS_HEADER_HEIGHT = 100;

const LedgerAccountsLayout = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

const LedgerAccountsHeaderSection = styled.div`
  height: ${LEDGER_ACCOUNTS_HEADER_HEIGHT}px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

const LedgerAccountsMainSection = styled.div`
  bottom: 0;
  left: 0;
  overflow: auto;
  position: absolute;
  right: 0;
  top: ${LEDGER_ACCOUNTS_HEADER_HEIGHT}px;
`;

type LedgerAccountsProps = {
  search: string,
  showAccountsOnly: boolean,
  showActiveOnly: boolean,
  tab: LedgerAccountsTabs,
  updateQueryParams: Object => void,
};

const LedgerAccounts = ({
  search,
  showAccountsOnly,
  showActiveOnly,
  tab,
  updateQueryParams,
}: LedgerAccountsProps) => {
  if (!tab) {
    updateQueryParams({ tab: ledgerAccountsTabs.LEDGER_ACCOUNTS });
  }

  const clearFiltersForSorting = () => {
    updateQueryParams({ search: '', showAccountsOnly: false, showActiveOnly: false });
  };

  const isSorting = !showAccountsOnly && !search;

  const client = useClient();

  return (
    <BKToolsErrorBoundary clientId={client.id} featureName="newLedgerAccounts">
      <LedgerAccountsLayout>
        <LedgerAccountsHeaderSection>
          <LedgerAccountsHeader
            search={search}
            showAccountsOnly={showAccountsOnly}
            showActiveOnly={showActiveOnly}
            tab={tab}
            updateQueryParams={updateQueryParams}
          />
        </LedgerAccountsHeaderSection>
        <LedgerAccountsMainSection>
          {tab === ledgerAccountsTabs.LEDGER_ACCOUNTS && (
            <LedgerAccountsTabContainer
              search={search}
              isSorting={isSorting}
              clearFiltersForSorting={clearFiltersForSorting}
              showAccountsOnly={showAccountsOnly}
              showActiveOnly={showActiveOnly}
            />
          )}
          {tab === ledgerAccountsTabs.ADDONS && (
            <AddonsTabContainer
              search={search}
              isSorting={isSorting}
              clearFiltersForSorting={clearFiltersForSorting}
            />
          )}
        </LedgerAccountsMainSection>
      </LedgerAccountsLayout>
    </BKToolsErrorBoundary>
  );
};

export default LedgerAccounts;

LedgerAccounts.defaultProps = {
  tab: undefined,
};
